import {
  Box,
  Card,
  BoxProps,
} from "@chakra-ui/react";
import { AdminLayout } from "@/components/layout/AdminLayout";

const defaultConfig  : BoxProps = {
    p : 4,
    h : "full",
    overflow : "hidden",
    display : "flex",
    flexDirection : "column"
}

interface BasePageLayoutI {
    children : React.ReactNode;
    mainBoxProps ?: typeof defaultConfig;
    hasCard ?: boolean;
    cardConfig ?: typeof defaultConfig;
}

export default function BasePageLayout({
    children, 
    mainBoxProps = defaultConfig,
    hasCard = false,
    cardConfig = defaultConfig
} : BasePageLayoutI) {
    return  <AdminLayout>
      <Box
      {...mainBoxProps} 
      >
        {
            hasCard ? (
                 <Card {...cardConfig}>
                    {children}
                </Card>
            ) : children
        }
      </Box>
    </AdminLayout>
}